const afterOpacity = (foreground, opacity, background = [255, 255, 255]) => foreground.map((section, index) => opacity * section + (1 - opacity) * background[index]);

export default (color, alpha = 0.1) => {
    const rgb = color.match(/\w\w/g).map((x) => parseInt(x, 16));
    return `rgb(${afterOpacity(rgb, alpha)})`;
};
